import React, { useEffect, useRef, useState } from "react";
import { answerPushPreprompt, getNotificationPreferences } from "../../api/user";
import { getPushPermission, requestPushPermission } from "../../utils/pushPermission";
import { PUSH_PREPROMPT_EVENT } from "../../utils/pushPreprompt";

// Push pre-prompt (Mantis 13084 / 13085). Mounted once in App; shown after the
// first limit or stop order, the first price alert, or the first league join /
// Cash Game entry - whichever comes first - when this device can still ask for
// permission. [Not now] does not open the browser/OS prompt, so the one iOS
// attempt is kept. The backend decides whether it may show (first time, or once
// more at least 7 days after [Not now]); after that only Settings asks.
const COPY = {
  order: "Get notified when your order fills.",
  alert: "Get notified the moment your price alert hits.",
  league: "Get notified when your league ends and see where you finished.",
};

const PushPreprompt = () => {
  const [kind, setKind] = useState(null);
  const checking = useRef(false);

  useEffect(() => {
    const onQualifyingEvent = async (e) => {
      if (checking.current || !localStorage.getItem("accessToken")) return;
      checking.current = true;
      try {
        if ((await getPushPermission()) !== "prompt") return;
        const res = await getNotificationPreferences();
        if (res?.data?.preprompt_allowed) setKind(e.detail?.kind);
      } catch (error) {
        console.log("Push pre-prompt check failed:", error);
      } finally {
        checking.current = false;
      }
    };
    window.addEventListener(PUSH_PREPROMPT_EVENT, onQualifyingEvent);
    return () => window.removeEventListener(PUSH_PREPROMPT_EVENT, onQualifyingEvent);
  }, []);

  if (!kind || !COPY[kind]) return null;

  const answer = (value) => {
    setKind(null);
    answerPushPreprompt(value).catch((error) => console.log(error));
    if (value === "turn_on") requestPushPermission();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative z-10 w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
        <p className="text-base font-medium text-gray-800">{COPY[kind]}</p>
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={() => answer("not_now")}
            className="h-12 flex-1 rounded-lg border bg-white font-semibold"
          >
            Not now
          </button>
          <button
            type="button"
            onClick={() => answer("turn_on")}
            className="h-12 flex-1 rounded-lg bg-primaryColor font-semibold text-white"
          >
            Turn on
          </button>
        </div>
      </div>
    </div>
  );
};

export default PushPreprompt;
